import React, { Fragment } from 'react';
import { CommonDropdown } from "./CommonDropdown";

export const genderValues = {
    MALE: 1,
    FEMALE: 2,
    NON_BINARY: 3,
    OTHER: 4,
}

const DropdownStaticGender = ( { control, name, rules, placeHolder, isSearchable, isClearable, isMulti, readOnly, validate } ) =>
{
    const items = [
        {
            value: genderValues.MALE,
            label: "Male"
        },
        {
            value: genderValues.FEMALE,
            label: 'Female'
        },
        {
            value: genderValues.NON_BINARY,
            label: 'Non-binary'
        },
        {
            value: genderValues.OTHER,
            label: 'Other'
        },
    ];

    return (
        <CommonDropdown key={name} items={items} control={control} name={name} rules={rules} placeholder={placeHolder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} />
    )
}

export default DropdownStaticGender;
